import styled from 'styled-components';
import { localTheme } from '../../../styles/local-theme';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '..';
import * as GStyled from '../../../styles/components';

const colorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.slateGray,
  blue: localTheme.colors.marinoBlue,
};

const borderColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.pureBlack,
  blue: localTheme.colors.darkBlue,
};

const StyledCategoriesPanel = styled(GStyled.ScrollableContainer)<
  SideNavColorSchemeProps
>`
  background-color: ${(props): string => colorSchemes[props.colorScheme]};
  display: flex;
  position: relative;
  box-shadow: inset -0.1rem 0 0.1rem ${(props): string => borderColorSchemes[props.colorScheme]};
  padding-right: 0.1rem;
`;

export default StyledCategoriesPanel;
